import identity from 'lodash/identity';
import { createCache, makeSwapperAxiosServiceMonadic } from '../../../utils';
const maxAge = 5 * 1000; // 5 seconds
const cachedUrls = ['/swap/v1/price', '/swap/permit2/price'];
const axiosConfig = {
    timeout: 10000,
};
export const zrxServiceFactory = ({ baseUrl, wrapper = identity, }) => {
    const cache = createCache(maxAge, cachedUrls, { ...axiosConfig, baseURL: baseUrl });
    const axiosInstance = wrapper(cache);
    return makeSwapperAxiosServiceMonadic(axiosInstance);
};
